// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EndMainDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    margin-left: -60px;
    margin-right: -60px;
    position: relative;
    overflow: hidden;
    z-index: 10;
    contain: paint layout style;
}

.EndMainDiv .primarybutton {
    margin-bottom: 60px;
}

.imageWrapper {
    position: relative;
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.imageWrapper::before {
    content: '';
    position: absolute;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: radial-gradient(circle,
            rgba(0, 224, 183, 0.668) 0%,
            rgba(0, 224, 183, 0.437) 35%,
            rgba(0, 224, 183, 0.189) 60%,
            transparent 80%);
    filter: blur(70px);
    z-index: 0;
}

.EndImage {
    width: 120px;
    position: relative;
    z-index: 2;
}

.curvedline {
    position: absolute;
    left: 50%;
    top: 8%;
    transform: translate(-50%, -50%);
    width: min(1400px, 200vw);
    height: 240px;
    border-bottom: 1px solid var(--curvedline-border);
    border-radius: 50%;
    z-index: 1;
    opacity: 0.9;
    filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.08));
}

.BottomTextAnimation {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--primary-bg-color);
    justify-content: flex-end;
    align-items: center;
    padding-top: 6vw;
    padding-bottom: 0;
    min-height: unset;
    z-index: 1;
    margin-top: -2px;
}

.endGlow {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 100%;
    height: 80%;
    background: linear-gradient(0deg,
            rgba(0, 224, 183, 0.7) 0%,
            rgba(0, 224, 183, 0.3) 40%,
            rgba(0, 200, 160, 0.1) 65%,
            transparent 100%);
    filter: blur(80px);
    pointer-events: none;
    z-index: 0;
}

.endVignette {
    position: absolute;
    inset: 0;
    background: var(--end-vignette);
    pointer-events: none;
    z-index: 1;
}

.endTitle {
    font-size: 12.8vw;
    font-weight: 800;
    text-align: center;
    letter-spacing: -0.04em;
    background: var(--end-title-gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    z-index: 2;
    line-height: 1.0;
    white-space: nowrap;
    margin: 0;
    -webkit-user-select: none;
            user-select: none;
    padding: 0;
    width: 100%;
    display: block;
    padding-bottom: 20px;
}

.endTitle:not(.endTitle-visible) {
  opacity: 0;
  transform: translateY(80px);
}

.endTitle.endTitle-visible {
  animation: end-reveal 1.4s cubic-bezier(0.25, 0.1, 0.25, 1) 0.15s both;
}

@keyframes end-reveal {
  from {
    opacity: 0;
    transform: translateY(80px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
    .EndMainDiv {
        margin-left: -20px;
        margin-right: -20px;
    }
}

@media (max-width: 480px) {
    .EndMainDiv {
        margin-left: -12px;
        margin-right: -12px;
    }

    .endTitle {
      font-size: 14vw;
    }

    .curvedline {
        height: 120px;
    }
}

.Primarysubheading {
    font-size: clamp(28px, 12vw, 60px);
    font-weight: 600;
    text-align: center;
    width: 100%;
    padding: 0 16px;
    margin: 0 0 20px;
}

.EndMainDiv .HighlightParagraph {
    font-size: clamp(22px, 6vw, 22px);
    width: 100%;
    text-align: center;
    padding: 0 16px;
    margin: 0 0 20px;
}

@media (max-width: 768px) {
    .Primarysubheading {
        font-size: clamp(24px, 12vw, 48px);
    }

    .EndMainDiv .HighlightParagraph {
        font-size: clamp(16px, 5vw, 20px);
    }
}

@media (max-width: 480px) {
    .Primarysubheading {
        font-size: clamp(22px, 14vw, 36px);
    }

    .EndMainDiv .HighlightParagraph {
        font-size: clamp(14px, 6vw, 18px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/BODY/END/end.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;;;;4BAIwB;IACxB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sDAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;IACnC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,WAAW;IACX;;;;6BAIyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,qCAAqC;IACrC,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;MACE,eAAe;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;AACJ","sourcesContent":[".EndMainDiv {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: auto;\n    margin-left: -60px;\n    margin-right: -60px;\n    position: relative;\n    overflow: hidden;\n    z-index: 10;\n    contain: paint layout style;\n}\n\n.EndMainDiv .primarybutton {\n    margin-bottom: 60px;\n}\n\n.imageWrapper {\n    position: relative;\n    width: 300px;\n    height: 300px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.imageWrapper::before {\n    content: '';\n    position: absolute;\n    width: 220px;\n    height: 220px;\n    border-radius: 50%;\n    background: radial-gradient(circle,\n            rgba(0, 224, 183, 0.668) 0%,\n            rgba(0, 224, 183, 0.437) 35%,\n            rgba(0, 224, 183, 0.189) 60%,\n            transparent 80%);\n    filter: blur(70px);\n    z-index: 0;\n}\n\n.EndImage {\n    width: 120px;\n    position: relative;\n    z-index: 2;\n}\n\n.curvedline {\n    position: absolute;\n    left: 50%;\n    top: 8%;\n    transform: translate(-50%, -50%);\n    width: min(1400px, 200vw);\n    height: 240px;\n    border-bottom: 1px solid var(--curvedline-border);\n    border-radius: 50%;\n    z-index: 1;\n    opacity: 0.9;\n    filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.08));\n}\n\n.BottomTextAnimation {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    background: var(--primary-bg-color);\n    justify-content: flex-end;\n    align-items: center;\n    padding-top: 6vw;\n    padding-bottom: 0;\n    min-height: unset;\n    z-index: 1;\n    margin-top: -2px;\n}\n\n.endGlow {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 100%;\n    height: 80%;\n    background: linear-gradient(0deg,\n            rgba(0, 224, 183, 0.7) 0%,\n            rgba(0, 224, 183, 0.3) 40%,\n            rgba(0, 200, 160, 0.1) 65%,\n            transparent 100%);\n    filter: blur(80px);\n    pointer-events: none;\n    z-index: 0;\n}\n\n.endVignette {\n    position: absolute;\n    inset: 0;\n    background: var(--end-vignette);\n    pointer-events: none;\n    z-index: 1;\n}\n\n.endTitle {\n    font-size: 12.8vw;\n    font-weight: 800;\n    text-align: center;\n    letter-spacing: -0.04em;\n    background: var(--end-title-gradient);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    position: relative;\n    z-index: 2;\n    line-height: 1.0;\n    white-space: nowrap;\n    margin: 0;\n    user-select: none;\n    padding: 0;\n    width: 100%;\n    display: block;\n    padding-bottom: 20px;\n}\n\n.endTitle:not(.endTitle-visible) {\n  opacity: 0;\n  transform: translateY(80px);\n}\n\n.endTitle.endTitle-visible {\n  animation: end-reveal 1.4s cubic-bezier(0.25, 0.1, 0.25, 1) 0.15s both;\n}\n\n@keyframes end-reveal {\n  from {\n    opacity: 0;\n    transform: translateY(80px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n    .EndMainDiv {\n        margin-left: -20px;\n        margin-right: -20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .EndMainDiv {\n        margin-left: -12px;\n        margin-right: -12px;\n    }\n\n    .endTitle {\n      font-size: 14vw;\n    }\n\n    .curvedline {\n        height: 120px;\n    }\n}\n\n.Primarysubheading {\n    font-size: clamp(28px, 12vw, 60px);\n    font-weight: 600;\n    text-align: center;\n    width: 100%;\n    padding: 0 16px;\n    margin: 0 0 20px;\n}\n\n.EndMainDiv .HighlightParagraph {\n    font-size: clamp(22px, 6vw, 22px);\n    width: 100%;\n    text-align: center;\n    padding: 0 16px;\n    margin: 0 0 20px;\n}\n\n@media (max-width: 768px) {\n    .Primarysubheading {\n        font-size: clamp(24px, 12vw, 48px);\n    }\n\n    .EndMainDiv .HighlightParagraph {\n        font-size: clamp(16px, 5vw, 20px);\n    }\n}\n\n@media (max-width: 480px) {\n    .Primarysubheading {\n        font-size: clamp(22px, 14vw, 36px);\n    }\n\n    .EndMainDiv .HighlightParagraph {\n        font-size: clamp(14px, 6vw, 18px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
